@if(isTabActive) {
<div class="d-lg-flex flex-row justify-content-end soap-header gap-3 mb-1 speech-container">
  @if(selectedSpeechProvider === 'azure'){
  <lib-speech-to-text (sendRecordedText)="recordedText($event)" (recognizing)="recognizingText($event)"
    (startAndStop)="checkStartAndStop($event)" [dateFormat]="'d MMM, y'" [startRecordingLabel]="''"
    [stopRecordingLabel]="''" [showDate]="false"></lib-speech-to-text>
  } @else if(selectedSpeechProvider === 'audio-chunks'){
  <cva-speech-to-text-chunked [dateFormat]="'d MMM, y'" [startRecordingLabel]="''" [stopRecordingLabel]="''"
    [minRecordingSeconds]="minRecordingSeconds" [maxRecordingSeconds]="maxRecordingSeconds"
    (startAndStop)="checkStartAndStop($event)" (sendRecordedText)="recordedText($event)"
    (recognizing)="recognizingText($event)" [isDectation]=true [showLabel]="false"
    (speechStatus)="onSpeechStatus($event)"></cva-speech-to-text-chunked>
  }
</div>
}

<div class="outer-border soap-content mx-2 notes-scroll-container" [hidden]="!isLoaded">
  <!-- Content starts -->
  <div class="d-md-flex generated-note-pane">
    @if (templateType) {
    <ng-container *ngTemplateOutlet="classicTemplate"></ng-container>
    }
  </div>
</div>
<div class="notes-action-footer" [hidden]="!isLoaded">
  @if(selectedTemplate && (selectedTemplate.category === TemplateCategory.NOTE) && !disableApprove) {
  <div class="approve-info d-flex flex-wrap align-items-center mt-2 pb-1">
    <div class="info-text d-flex align-items-center">
      <i class="bi bi-info-circle-fill me-2 margin-neg-15"></i>
      <span class="margin-l-neg-28">
        Please review your notes before approval to ensure it accurately reflects the consultation.
      </span>
    </div>
    <div class="button-group">
      <button type="button" class="btn btn-dark me-2 btn-sm" mdbRipple (click)="approveNotes()" cvaAuthPermCheck
        [moduleName]='CVA_AUTH_MODULES.CVA_SOAP_NOTES' [permissionType]='CVA_CONSTANTS.PERMISSION.WRITE'
        [actionType]='"disable"'
        [disabled]="disableApprove || isApproving || !transcription || transcription.trim().length === 0">
        Approve
      </button>
      <cva-generate-button [name]="'Generate More'" (actionClick)="generateMore($event)"
        [noteTemplateListing]="noteTemplateListing" [hasDefaultTemplate]="hasDefaultTemplate"
        [DEFAULT_PREFERRED_TEMPLATE]="DEFAULT_PREFERRED_TEMPLATE" [transcription]="transcription"
        [appointmentRefId]="appointment.referenceId" [vitals]="vitals" [patientHistory]="patientHistory">
      </cva-generate-button>
    </div>
  </div>
  } @else {
  <div class="d-flex justify-content-end m-top-7">
    <!-- <button type="button" class="btn btn-dark me-2 btn-sm" (click)="copyToClipboard('classic-txt'+tabIndex)">
      Copy To Clipboard
    </button> -->
    <cva-generate-button [name]="'Generate More'" (actionClick)="generateMore($event)"
      [noteTemplateListing]="noteTemplateListing" [hasDefaultTemplate]="hasDefaultTemplate"
      [DEFAULT_PREFERRED_TEMPLATE]="DEFAULT_PREFERRED_TEMPLATE" [transcription]="transcription"
      [appointmentRefId]="appointment.referenceId" [vitals]="vitals"
      [patientHistory]="patientHistory"></cva-generate-button>
  </div>
  }
</div>

<div *ngIf="isApproving" class="approve-global-loader">
  <div class="approve-global-loader-content">
    <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
    <span>Approving notes, please wait...</span>
  </div>
</div>

<ng-template #classicTemplate>
  <div class="w-100">
    @if (useRtfEditor) {
    <cva-rtf-editor class="mt-2 note-editor-host" #rtfEditor
      [ngClass]="(selectedTemplate && selectedTemplate.category !== TemplateCategory.NOTE) ? 'full-height' : 'reduce-height'"
      [formControl]="tabControl" [attr.id]="useRtfEditor ? 'classic-txt' + tabIndex : null">
    </cva-rtf-editor>
    } @else {
    <textarea class="form-control mt-2 generated-note-textarea" [formControl]="tabControl"
      [attr.id]="!useRtfEditor ? 'classic-txt' + tabIndex : null" rows="12">
    </textarea>
    }

    <div *ngIf="vitals.length > 0 && selectedTemplate && selectedTemplate.category === TemplateCategory.NOTE"
      class="mat-expansion-panel ">
      <div class="sub-section border border-light-subtle card p-3">
        <h4 class="fw-medium fs-6 m-0"> Vital Signs </h4>
        <div class="sub-section-content">
          <div class="objective-table m-top-7">
            <table>
              <tr>
                <th>Parameters </th>
                <th>Value</th>
                <th>Action</th>
              </tr>
              <tr *ngFor="let v of vitals; let i = index">
                <td>
                  {{ v.title }}
                  <span *ngIf="v.unit">({{ v.unit }})</span>
                </td>
                <td>
                  @if (v.type === 'dropdown') {
                  <cva-custom-select [id]="v.title" [selectedValue]="v.value" [isActivated]="tempEdit.parentIndex === i"
                    [additionalParams]="{sectionIndex : -1, subSectionIndex:-1, index: i, column:-1}"
                    (getUpdatedValue)="selectTextCustom($event)" (directClicked)="valueSelectedVitals($event)"
                    [options]="v.data"></cva-custom-select>
                  }
                  @else {
                  <input [(ngModel)]="v.value" [id]="v.title" (blur)="checkVitalInput(i)" autocomplete="off"
                    (click)="editvalue(i)" />
                  }
                </td>
                <td class="text-center">
                  <button type="button" class="no-button" (click)="clearValue(i)">
                    <img [src]="cvaUI_url + '/assets/icons/delete.svg'" alt="delete icon" />
                  </button>
                  <button type="button" class="no-button" (click)="editvalue(i)">
                    <img src="assets/icons/edit.svg" alt="edit icon" />
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>